// =====================================================================
// PLENARIUM:VOTO_MESA -- a Mesa registra o voto de quem teve problema no
// tablet. So com a votacao aberta e nunca em votacao secreta. O voto fica
// marcado "registrado pela Mesa" na ata e no relatorio. Quem ja votou pelo
// tablet nao pode ter o voto trocado pela Mesa.
// =====================================================================
import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { X, Vote } from 'lucide-react';

const ROT = { SIM: 'SIM', NAO: 'NÃO', ABSTENCAO: 'ABSTENÇÃO' };
const COR = { SIM: '#16a34a', NAO: '#dc2626', ABSTENCAO: '#64748b' };

function ModalVotoMesa({ pauta, vereadores, onClose }) {
  const [dados, setDados] = useState(null);
  const [ocupado, setOcupado] = useState(null);
  const carregar = useCallback(async () => {
    try { const r = await axios.get(`/api/votacao/mesa/${pauta.id}`); setDados({ votos: r.data.votos || {}, mesa: new Set(r.data.mesa || []) }); }
    catch (e) { setDados({ votos: {}, mesa: new Set(), erro: (e.response && e.response.data && e.response.data.error) || 'Não foi possível carregar os votos.' }); }
  }, [pauta.id]);
  useEffect(() => { carregar(); const t = setInterval(carregar, 5000); return () => clearInterval(t); }, [carregar]);
  const registrar = async (v, opcao) => {
    if (!window.confirm(`Registrar o voto de ${v.nome}: ${ROT[opcao]}?\n\nO voto fica marcado como "registrado pela Mesa" na ata e no relatório.`)) return;
    setOcupado(v.id);
    try { await axios.post('/api/votacao/mesa', { pautaId: pauta.id, vereadorId: v.id, opcao }); toast.success(`Voto de ${v.nome} registrado pela Mesa.`); await carregar(); }
    catch (e) { toast.error((e.response && e.response.data && e.response.data.error) || 'Não foi possível registrar o voto.'); }
    finally { setOcupado(null); }
  };
  const lista = (vereadores || []).filter(v => v && v.ativo !== false).slice().sort((a, b) => String(a.nome).localeCompare(String(b.nome), 'pt-BR'));
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 620 }}>
        <div className="modal-header">
          <h2 className="modal-title"><Vote size={16} /> Registrar voto pela Mesa</h2>
          <button className="btn-modal-close" onClick={onClose}><X size={18} /></button>
        </div>
        <p style={{ fontSize: '0.8rem', color: 'var(--texto-suave)', margin: '0 0 12px' }}>
          <b>{pauta.numero}</b> — use só quando o tablet do vereador falhar. O voto fica marcado como <b>registrado pela Mesa</b> na ata e no relatório. Quem já votou pelo tablet não aparece para troca.
        </p>
        {!dados ? <div style={{ textAlign: 'center', padding: 24 }}><div className="spinner" /></div>
          : dados.erro ? <div className="card" style={{ padding: 14, color: 'var(--reprovado)' }}>{dados.erro}</div>
          : (
            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              {lista.map(v => {
                const op = dados.votos[v.id];
                const daMesa = dados.mesa.has(v.id);
                const peloTablet = op && !daMesa;
                return (
                  <div key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '1px solid var(--cinza)', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: 160 }}>
                      <p style={{ fontWeight: 600, fontSize: '0.85rem' }}>{v.nome}</p>
                      <p style={{ fontSize: '0.72rem', color: op ? COR[op] : 'var(--texto-suave)', fontWeight: op ? 700 : 400 }}>
                        {!op ? 'Ainda não votou' : `${ROT[op]} · ${daMesa ? 'registrado pela Mesa' : 'votou no tablet'}`}
                      </p>
                    </div>
                    {!peloTablet && ['SIM', 'NAO', 'ABSTENCAO'].map(o => (
                      <button key={o} type="button" className="btn btn-sm" disabled={ocupado === v.id || op === o} onClick={() => registrar(v, o)}
                        style={{ background: op === o ? COR[o] : '#fff', color: op === o ? '#fff' : COR[o], border: `1px solid ${COR[o]}`, fontWeight: 700 }}>{ROT[o]}</button>
                    ))}
                  </div>
                );
              })}
            </div>
          )}
        <div className="modal-actions" style={{ marginTop: 12 }}>
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

export function BotaoVotoMesa({ pauta, vereadores }) {
  const [aberto, setAberto] = useState(false);
  if (!pauta || pauta.status !== 'EM_VOTACAO' || pauta.votacaoSecreta) return null;
  return (
    <>
      <button className="btn btn-secondary btn-sm" onClick={() => setAberto(true)} title="Quando o tablet de um vereador falhar"><Vote size={13} /> Registrar voto (Mesa)</button>
      {aberto && <ModalVotoMesa pauta={pauta} vereadores={vereadores} onClose={() => setAberto(false)} />}
    </>
  );
}

export default BotaoVotoMesa;
